import { useAction } from '@sde/widgets-core/src/redux/hooks/useAction';
import { useSelect } from '@sde/widgets-core/src/redux/hooks/useSelect';
import { setTutorialActive, setTrainingTipsActive } from './actions';

const tutorialSelector = (state) => state.tutorial;

export const useTutorial = {
  state: () => {
    return useSelect(tutorialSelector);
  },
  actions: () => {
    return {
      setTutorialActive: useAction(setTutorialActive),
      setTrainingTipsActive: useAction(setTrainingTipsActive),
    };
  },
};
